export default __webpack_public_path__ + "static/media/img--bathroom-dark.cd1ca840.jpg";